import axios from 'axios'
import { useCookies } from 'vue3-cookies'
// eslint-disable-next-line import/no-useless-path-segments
import { deleteToken } from '../api/loginout'

const { cookies } = useCookies()
const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})
export default instance

let getAcc = ''
let getRef = ''
let headers = ''

// eslint-disable-next-line consistent-return
export async function chekcAccT() {
  getAcc = cookies.get('access_token')
  getRef = cookies.get('refresh_token')
  // headers = { Authorization: getAcc }
  try {
    // 토큰이 만료되지 않았을때만 try문으로 들어옴.
    if (getAcc) {
      // access_token이 있는 상황 ==> 로그인을 한 상황
      // "MB23000200" -> 유효기간 내
      headers = { Authorization: getAcc }
      const chkAT = await instance.get(`/api/v1/member/token`, { headers })
      console.log('chekcAccT 함수 내부')
      console.log(chkAT.data)
      console.log(chkAT.data.code) // "MB23000200" etc
      return chkAT.data.code
    }
  } catch (error) {
    // alert(error)
    console.log(error)
    console.log(error.response.data.code)
    return error.response.data.code
    /*
    {
    "status_code": 400,
    "msg": "토큰이 만료되었습니다.",
    "detail": "Token expired.",
    "code": "4000001"
    }
    */
  }
}

export async function testAxiosGet() {
  getAcc = cookies.get('access_token')
  getRef = cookies.get('refresh_token')

  if (getAcc) {
    headers = { Authorization: getAcc }
    await instance
      .get('/api/v1/member/token', { headers })
      .then((response) => {
        const codeData = response.data.code
        console.log(
          'testAxiosGet에서 codeData를 401에러 if문 만나기 전부터 찍어보기 ::: ',
          codeData
        )
        // console.log(codeData)
        if (codeData === 'AU4010001') {
          instance.post('/api/v1/member/auth/token', { refesch_token: getRef })
        } else {
          // MB23000200 정상 로그인 코드
          console.log('complet')
        }
      })
      .catch((error) => {
        console.log('error ::: ', error)
        console.log('error.response ::: ', error.response)
        console.log('error.response.data ::: ', error.response.data)
        console.log(
          'error.response.data.status_code ::: ',
          error.response.data.status_code
        )
        // eslint-disable-next-line no-use-before-define
        // checkValidity(error.response.data.status_code)
      })
  } else {
    console.log('uncomp')
  }
}

// eslint-disable-next-line consistent-return
export async function checkValidity(status) {
  try {
    console.log('checkValidity로 들어온 status값을 찍어보자 :::: ', status)
    // console.log(status)
    if (status === 400) {
      // eslint-disable-next-line prettier/prettier
      const renewData = { 'refresh_token': getRef }
      const renewRes = await instance.post(
        `/api/v1/member/auth/token`,
        renewData
      )
      getAcc = cookies.set('access_token', renewRes.data.content.access_token)
      // eslint-disable-next-line prettier/prettier
      headers = {'Authorization' : getAcc}
      await instance.get(`/api/v1/member/token`, { headers })
    } else if (status === 404) {
      alert('로그아웃되었습니다.')
      // deleteToken()
      return status
    }
  } catch (err) {
    console.log(err)
    // console.log(err)
    // if(err.response.data.code == "4040011"){
    alert(err)
    alert('catch문에 걸렸습니다.')
    alert('로그아웃되었습니다.')
    //   deleteToken();
  }
}

// let chkVal = ""
// getAcc = cookies.get("access_token")
// getRef = cookies.get("refresh_token")

// // console.log(getAcc);
// // console.log(getRef);
// try{
//   headers = {'Authorization' : getAcc}
//   chkVal = await instance.get(`/api/v1/member/token`, {headers})
//   // console.log(chkVal)
//   // console.log(chkVal.data.status_code)
//   // console.log("토큰갱신 필요 없음")

// }
// catch (err){
//   // console.log(err.response.data.status_code);
//   // console.log(err);
//   // if(chkVal.data.status_code == 400){
//   if(err.response.data.status_code == 400){
//     // console.log("토큰 갱신 진입");
//     const renewData = {"refresh_token" : getRef}
//     const renewRes = await instance.post(`/api/v1/member/auth/token`, renewData)
//     // console.log(renewRes)
//     getAcc = cookies.set('access_token', renewRes.data.content.access_token)
//     // console.log(getAcc)
//     headers = {'Authorization' : getAcc}
//     chkVal = await instance.get(`/api/v1/member/token`, {headers})
//     // console.log("토큰갱신 완료")
//   }
//   else{
//     // console.log("토큰갱신 필요 없음")
//   }

// }
// // console.log(err.response.data.status_code)
// if(err.response.data.status_code == 400){
//   // const renewData = {"refresh_token":getRef}
//   try{
//     // console.log("리프레쉬 토큰 출력 : ", getRef);
//     // const renewRes = await instance.post(`/api/v1/member/auth/token`, renewData)
//     const renewRes = await instance.post(`/api/v1/member/auth/token`, {"refresh_token":getRef})
//     // console.log(renewRes)
//     getAcc = cookies.set('access_token', renewRes.data.content.access_token)
//     headers = {'Authorization' : getAcc}
//     chkVal = await instance.get(`/api/v1/member/token`, {headers})
//     // console.log("토큰갱신 완료")
//   } catch (err){
//     // console.log(err);
//   }
// }
// else{
//   // console.log("토큰갱신 필요 없음")
// }
// }

export async function loadContentsList() {
  const pageIndex = 1
  const pageSize = 10
  // eslint-disable-next-line prettier/prettier
  const params = { 'cfc_name': '', 'title': '' }

  const contentsRes = await instance.get(
    `/api/v1/lecture/intro/contents?page_size=${pageSize}&page_index=${pageIndex}`,
    params
  )
  // console.log(contentsRes);
  // let contentList = contentsRes.data.content
  // console.log(contentList);
  // eslint-disable-next-line no-unused-expressions
  contentsRes.data.content
  return contentsRes.data
}
